module.exports = __webpack_public_path__ + "static/10-crumb-a8aec076fb6cbe6961023268e07a49d4.jpg";